import useStoreMonitor from "../warehouse/useStoreMonitor";

let count = 1;

/**
 * 
 * @returns {WeakMap}
 */
function useWeakMap() {
    const weakMap = new WeakMap(...arguments);
    // if(count=== 529) debugger;
    useStoreMonitor(`weak-${count++}`, weakMap);
    return weakMap;
}

export default useWeakMap;